import { ActionButton } from "@/shared/ui/action-button"
import DeleteSvg from '@/shared/assets/images/Trash.svg'
import { useUpdatePartnerDiscountModals } from "@/features/update-partner-discount"
import { useAppDispatch } from "@/shared/lib/redux"
import { fetchPartnerDiscounts } from "../../model"
import { IPartnerDiscount } from "@/shared/api/partners"
import { FC } from "react"

interface DeleteDiscountProps {
    discount: IPartnerDiscount
}

export const DeleteDiscount: FC<DeleteDiscountProps> = ({ discount }) => {
    const { openDeleteDiscountModal } = useUpdatePartnerDiscountModals()
    const dispatch = useAppDispatch()

    const onDelete = () => {
        dispatch(fetchPartnerDiscounts())
    }

    return (
        <ActionButton 
            onClick={() => openDeleteDiscountModal(discount, onDelete)}
            icon={DeleteSvg} 
        />
    )
}